module.exports = __webpack_public_path__ + "img/back-office.9600ea4b.svg";